import { default as RestReviews } from './RestReviews'
export default RestReviews
export * as rest_reviews from './model'
